import styled from 'styled-components';

export const LoadingWrapper = styled.div`
  width: clamp(20vw, 40rem, 100vw);
  height: clamp(20vw, 40rem, 100vw);
  margin: 0 auto;
  border-radius: 50%;
  overflow: hidden;
`;

export const MainScreen = styled.div`
  height: 100%;
  height: calc(100vh - 5rem);
  background-color: ${props => props.color};
  padding: 0px 20px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;

  .content {
    margin-top: -5rem;
    color: #fff;
    width: 60rem;
    line-height: 3rem;
    max-width: 90%;

    .title {
      font-size: 18px;
      margin-bottom: 10px;
      font-weight: 600;
      display: inline-block;
    }
  }

  .countdown {
    font-size: 2rem;
    margin-bottom: 2rem;
  }

  button {
    margin-top: 2rem;
  }
`;

export const AvatarWrapper = styled.div`
  position: relative;
`;



// WEBPACK FOOTER //
// ./src/routes/SpeedDatingRandomMeeting/components/styles.js